import { render, staticRenderFns } from "./SettingsAccountPage.vue?vue&type=template&id=6571c876"
import script from "./SettingsAccountPage.vue?vue&type=script&lang=ts"
export * from "./SettingsAccountPage.vue?vue&type=script&lang=ts"
import style0 from "./SettingsAccountPage.vue?vue&type=style&index=0&id=6571c876&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports